import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import fetchClient from '../../utils/fetchClient';

// Async thunk для загрузки данных уровня
export const fetchUserLevel = createAsyncThunk(
    'userLevel/fetch',
    async (_, { rejectWithValue }) => {
        try {
            console.log('🔄 Fetching user level data from API...');
            const response = await fetchClient.get('/user-game-data/level-info');
            console.log('✅ User level data fetched successfully:', response);
            return response;
        } catch (error) {
            console.error('❌ Error fetching user level data:', error);
            return rejectWithValue(error.message);
        }
    }
);

const userLevelSlice = createSlice({
    name: 'userLevel',
    initialState: {
        data: null,
        features: [],
        loading: false,
        error: null,
        lastFetch: null
    },
    reducers: {
        clearUserLevel: (state) => {
            console.log('🧹 Clearing user level data');
            state.data = null;
            state.features = [];
            state.error = null;
            state.lastFetch = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserLevel.pending, (state) => {
                console.log('⏳ User level fetch pending...');
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUserLevel.fulfilled, (state, action) => {
                console.log('✅ User level fetch fulfilled');
                state.loading = false;
                state.data = {
                    level: action.payload.current_level,
                    experience: action.payload.current_exp,
                    exp_to_next: action.payload.exp_to_next,
                    progress_percent: action.payload.progress_percent,
                    features_list: action.payload.features_list || {}
                };
                state.features = action.payload.available_features || [];
                state.lastFetch = Date.now();
                state.error = null;
            })
            .addCase(fetchUserLevel.rejected, (state, action) => {
                console.error('❌ User level fetch rejected:', action.payload);
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { clearUserLevel } = userLevelSlice.actions;
export default userLevelSlice.reducer;
